import { delay, http, HttpResponse } from 'msw';

export const handlers = [
  http.get('*/json/v1/authentication/user', async () => {
    await delay(150);
    return HttpResponse.json({
      id: 114109369,
      name: 'knamburi@sumologic.com',
      firstName: 'Krishna',
      lastName: 'Namburi',
      organization: 'cse-stag-sandbox',
      organizationId: 111992367,
      switchableOrgs: [],
      __typename: 'CurrentUserSumo',
      emailVerified: true,
      accountStatus: 'activated',
      orgCreationDate: 1637328942245,
      dynamicProperties: {},
      isChildOrgUser: false,
      isInitialSetupRequired: false,
    });
  }),
];
